export class LaborManagementHubActions {}
